import React, { FunctionComponent, ReactElement } from "react";

import { Attribute, AttributeProps, Badge, BadgeVariant } from "@multiweb/reactComponents";
import { IconCode, OWDataType } from "@multiweb/types/contracts";
import { FrameAttributeSharedProps } from "../../types";
import { DocumentDownload } from "../DocumentDownload";
import { IconNameAttribute } from "../IconNameAttribute";

export type FrameAttributeComponentProps = Readonly<FrameAttributeSharedProps & AttributeProps & {
    /** Popisek atributu. */
    title?: string;
    /** Pevná ikona, která se zobrazí spolu s hodnotou atributu. */
    iconCode?: IconCode;
}>;

/** Komponenta vykreslující datové typy specifické pro framy. */
export const FrameAttributeComponent: FunctionComponent<FrameAttributeComponentProps> = ({
    dataSourceKey,
    recordId,
    attributeName,
    value,
    type,
    displayFormat = null,
    interactive = true,
    title,
    hasBackgroundAttr = false,
    iconCode,
}) => {
    const modifiedType = type?.startsWith("Enum|") ? OWDataType.enum : type;
    let innerComponent: ReactElement;
    switch (modifiedType) {
        case OWDataType.document:
            innerComponent = <DocumentDownload
                attributeValue={value.toLocaleString()}
                {...{ recordId, dataSourceKey, attributeName, interactive, hasBackgroundAttr, iconCode }} />;
            break;
        default:
            innerComponent = <Attribute
                {...{ value, attributeName, type, displayFormat, interactive, title, hasBackgroundAttr: iconCode ? false : hasBackgroundAttr, iconCode }} />;
    }

    if (iconCode) {
        return withIconName(innerComponent, iconCode, hasBackgroundAttr);
    } else if (hasBackgroundAttr) {
        return withBadge(innerComponent);
    } else {
        return innerComponent;
    }
};

const withBadge = (component: React.ReactElement) => <Badge variant={BadgeVariant.backgroundAttr}>{component}</Badge>;
const withIconName = (component: React.ReactElement, iconCode: IconCode, hasBackgroundAttr: boolean) => <IconNameAttribute {...{ iconCode, hasBackgroundAttr }}>{component}</IconNameAttribute>;
